import Header from './components/Header'
import Hero from './sections/Hero'
import About from './sections/About'
import Features from './sections/Features'
import HowItWorks from './sections/HowItWorks'
import Testimonials from './sections/Testimonials'
import Screenshots from './sections/Screenshots'
import Availability from './sections/Availability'
import Contact from './sections/Contact'
import Footer from './components/Footer'

function App() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Features />
      <HowItWorks />
      <Testimonials />
      <Screenshots />
      <Availability />
      <Contact />
      <Footer />
    </>
  )
}

export default App 